import FieldTypesEnum from "../Enums/FieldTypesEnum";
import React from 'react';
import FigmaBadge from "../Elements/FigmaBadge";
import LongText from "../Elements/LongText";
import DataTableActionMenu from "../Elements/DataTable/DataTableActionMenu";

class ProjectSurveyItem
{
    constructor (item)
    {
        if (item === undefined)
        {

            this.SurveyId = "";
            this.Name = "";
            this.ClientName = "";
            this.IsUninvoiceable = "";
            this.ActiveProjectNames = "";
            this.InactiveProjectNames = "";
            this.ProjectId = "";
            this.SassieId = "";
            return;
        }
        this.SurveyId = item.surveyId;
        this.Name = item.name;
        this.ClientName = item.clientName;
        this.IsUninvoiceable = item.isUninvoiceable;
        this.ActiveProjectNames = item.activeProjectNames;
        this.InactiveProjectNames = item.inactiveProjectNames;
        this.ProjectId = item.projectId;
        this.SassieId = item.sassieId;
    }

    static NameOfTheIdField ()
    {
        return "SurveyId";
    }

    static editGeneralFunction = (id, user, userList) =>
    {
        alert("Empty function");
    };

    static nameOfTheItemDetailList ()
    {
        return "Name";
    }

    static MoneyFields = [];

    static Currency ()
    {
        return "";
    }

    static MoneyFieldsSecondary = [];

    static CurrencySecondary ()
    {
        return "";
    }

    static DateFields = [];
    static BoolFields = [ "IsUninvoiceable" ];
    static FieldsToShowInListTable = [];
    static FieldsToShowInDataTable ()
    {
        return [
            {
                label: "Survey Id",
                orderById: "SassieId",
                data: "SassieId",
                type: FieldTypesEnum.PureDataField,
                minWidth: 70,
                className: "text-left",
            },
            {
                label: "Name",
                orderById: "Name",
                data: "Name",
                type: FieldTypesEnum.PureDataField,
                className: "text-left",
            },
            {
                label: "Client",
                orderById: "ClientName",
                data: "ClientName",
                type: FieldTypesEnum.PureDataField,
                className: "text-left",
            },
            {
                label: "Uninvoiceable?",
                orderById: "IsUninvoiceable",
                data: item => ProjectSurveyItem.getBadgeContent(item.IsUninvoiceable),
                type: FieldTypesEnum.PureDataField,
                className: "text-left",
            },
            {
                label: "Current Projects",
                orderById: "ActiveProjectNames",
                data: "ActiveProjectNames",
                type: FieldTypesEnum.PureDataField,
                className: "text-left",
            },
            {
                label: "Past/Future Projects",
                orderById: "InactiveProjectNames",
                data: item => <LongText text={item.InactiveProjectNames ? item.InactiveProjectNames : ""} maxLength={50} type="info" />,
                type: FieldTypesEnum.PureDataField,
                className: "text-left",
            },
            {
                label: " ",
                orderById: "",
                data: ProjectSurveyItem.getActionsContent,
                type: FieldTypesEnum.ActionButton,
            },
        ];
    }

    static editFunction = (id, item, itemList) =>
    {
        alert("Empty function");
    };

    static removeFunction = (item, itemList) =>
    {
        alert("Empty function");
    };

    static getActionsContent (item)
    {
        return (
            <DataTableActionMenu
                options={[
                    {
                        iconName: "fa-regular fa-trash-can",
                        text: "Remove",
                        onClick: () => ProjectSurveyItem.removeFunction(item),
                        roleKey: "project_removesurvey"
                    }
                ]}
            />
        );
    }
    static getBadgeContent (item)
    {
        return (
            <div>
                <FigmaBadge Active={item} ActiveText="Yes" InactiveText="No" width={50} />
            </div>
        );
    }
}

export default ProjectSurveyItem;